var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 200,
    viewBox: "0 0 640 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 430.69 -117.1)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -240.5 539.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(244,238,217)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -456.5,
    rx: 0,
    ry: 0,
    width: 159,
    height: 913
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -232.25 156)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(10,11,15)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -69.75,
    y: -62,
    rx: 0,
    ry: 0,
    width: 139.5,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -231.25 116)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -70.25,
    y: -3.5,
    rx: 0,
    ry: 0,
    width: 140.5,
    height: 7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -260.5 156)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -62,
    rx: 0,
    ry: 0,
    width: 5,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -168.5 156)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -62,
    rx: 0,
    ry: 0,
    width: 5,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -212.5 156)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -5.5,
    y: -62,
    rx: 0,
    ry: 0,
    width: 11,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -220.25 272.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(10,11,15)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -31.75,
    y: -31.75,
    rx: 0,
    ry: 0,
    width: 63.5,
    height: 63.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -218.5 273)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -32,
    rx: 0,
    ry: 0,
    width: 5,
    height: 64
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -240.5 229.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -11,
    rx: 0,
    ry: 0,
    width: 159,
    height: 22
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -232.5 91.5)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -71,
    y1: 0,
    x2: 71,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -240.25 240.5)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -79.25,
    y1: 0,
    x2: 79.25,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -163.25 104)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.25,
    y: -8.5,
    rx: 0,
    ry: 0,
    width: 4.5,
    height: 17
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -163.25 167.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.25,
    y: -48.25,
    rx: 0,
    ry: 0,
    width: 4.5,
    height: 96.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -81.5 539.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(244,238,217)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -456.5,
    rx: 0,
    ry: 0,
    width: 159,
    height: 913
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -73.25 156)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(10,11,15)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -69.75,
    y: -62,
    rx: 0,
    ry: 0,
    width: 139.5,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -72.25 116)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -70.25,
    y: -3.5,
    rx: 0,
    ry: 0,
    width: 140.5,
    height: 7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -101.5 156)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -62,
    rx: 0,
    ry: 0,
    width: 5,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -9.5 156)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -62,
    rx: 0,
    ry: 0,
    width: 5,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -53.5 156)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -5.5,
    y: -62,
    rx: 0,
    ry: 0,
    width: 11,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -61.25 272.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(10,11,15)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -31.75,
    y: -31.75,
    rx: 0,
    ry: 0,
    width: 63.5,
    height: 63.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -59.5 273)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -32,
    rx: 0,
    ry: 0,
    width: 5,
    height: 64
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -81.5 229.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -11,
    rx: 0,
    ry: 0,
    width: 159,
    height: 22
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -73.5 91.5)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -71,
    y1: 0,
    x2: 71,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -81.25 240.5)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -79.25,
    y1: 0,
    x2: 79.25,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -4.25 104)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.25,
    y: -8.5,
    rx: 0,
    ry: 0,
    width: 4.5,
    height: 17
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -4.25 167.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.25,
    y: -48.25,
    rx: 0,
    ry: 0,
    width: 4.5,
    height: 96.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 75.5 540.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(244,238,217)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -456.5,
    rx: 0,
    ry: 0,
    width: 159,
    height: 913
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 83.75 157)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(10,11,15)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -69.75,
    y: -62,
    rx: 0,
    ry: 0,
    width: 139.5,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 84.75 117)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -70.25,
    y: -3.5,
    rx: 0,
    ry: 0,
    width: 140.5,
    height: 7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55.5 157)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -62,
    rx: 0,
    ry: 0,
    width: 5,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 147.5 157)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -62,
    rx: 0,
    ry: 0,
    width: 5,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 103.5 157)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -5.5,
    y: -62,
    rx: 0,
    ry: 0,
    width: 11,
    height: 124
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 95.75 273.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(10,11,15)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -31.75,
    y: -31.75,
    rx: 0,
    ry: 0,
    width: 63.5,
    height: 63.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 97.5 274)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -32,
    rx: 0,
    ry: 0,
    width: 5,
    height: 64
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 75.5 230.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -11,
    rx: 0,
    ry: 0,
    width: 159,
    height: 22
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 83.5 92.5)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -71,
    y1: 0,
    x2: 71,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 75.75 241.5)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -79.25,
    y1: 0,
    x2: 79.25,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 152.75 105)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.25,
    y: -8.5,
    rx: 0,
    ry: 0,
    width: 4.5,
    height: 17
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 152.75 168.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.25,
    y: -48.25,
    rx: 0,
    ry: 0,
    width: 4.5,
    height: 96.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToit);
export default __webpack_public_path__ + "static/media/toit.bdbc336d7715d268ab59bd9e8b2a93bd.svg";
export { ForwardRef as ReactComponent };